import { Sheet, SheetContent } from 'app/components/ui/sheet'
import { showQuickCreateTask } from 'app/lib/quickCreateTask'
import type { ContactJson, TaskJson } from 'app/types/entities'
import { TaskDetailPane, type TaskFieldInput } from './TaskDetailPane'

/**
 * The task drawer every task surface opens (Tasks calendar, Action Center's
 * My tasks card), so a task reads and edits the same wherever it is clicked.
 */
export function TaskDetailSheet({
  task,
  onClose,
  onToggleStatus,
  onUpdate,
  onDelete,
  onOpenContact,
  onTaskCreated,
}: {
  task: TaskJson | undefined
  onClose: () => void
  onToggleStatus: (task: TaskJson) => void
  onUpdate: (taskId: string, input: TaskFieldInput) => Promise<boolean>
  onDelete: (taskId: string) => Promise<boolean>
  onOpenContact: (task: TaskJson) => void
  onTaskCreated: () => void
}) {
  return (
    <Sheet open={!!task} onOpenChange={(open) => !open && onClose()}>
      <SheetContent side="right" className="w-full sm:w-3/4">
        {task && (
          <TaskDetailPane
            task={task}
            onCheck={() => onToggleStatus(task)}
            onClose={onClose}
            onOpenContact={() => onOpenContact(task)}
            onCreateFollowUp={(contact) =>
              showQuickCreateTask({
                defaultContact: {
                  id: contact.id,
                  name: contact.name || `Unknown`,
                  locationId: contact.locationId,
                } as ContactJson,
                onCreated: onTaskCreated,
              })
            }
            onUpdate={(input) => (task.id ? onUpdate(task.id, input) : Promise.resolve(false))}
            onDelete={onDelete}
          />
        )}
      </SheetContent>
    </Sheet>
  )
}
